import React, { useEffect, useState } from "react";
import { useRef } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./Home.css";
import { 
  FaChartBar, 
  FaBoxes, 
  FaUsers, 
  FaMoneyBillWave, 
  FaTruck, 
  FaUserShield 
} from "react-icons/fa";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCreative, Autoplay, Pagination, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-creative";
import "swiper/css/pagination";
import "swiper/css/navigation";
import lerp from "../../assets/lerp.png";
import plan from "../../assets/plan.png";
import Equip from "../../assets/Equip.png";
import barcode from "../../assets/barcode.png";
import collab from "../../assets/collab.png";
import trace from "../../assets/trace.png";
import ai from "../../assets/ai.png";
import cloud from "../../assets/clouderp.png";
import {  FaIndustry, FaMicrochip,FaPlug ,FaNetworkWired  } from "react-icons/fa";


import mes from "../../assets/mes-bg.mp4";
import ERPChatbot from "../../components/ERPChatbot/ERPChatbot";
import Header from "../../components/Header/Header";
import emailjs from "@emailjs/browser";
import Footer from "../../components/Footer/Footer";




const Homepage = () => {
  const [menuOpen, setMenuOpen] = useState(false);
    const [openMenu, setOpenMenu] = useState(null); 
      const formRef = useRef();
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();
    setSending(true);
    setSent(false);
    setError(false);

    emailjs
      .sendForm(
        "service_umkel1i", // e.g. "service_9jk1b8s"
        "template_3ndc6u2", // e.g. "larch_contact_form"
        formRef.current,
        // "UnzzqbY-4HsjFtDCe" // e.g. "AWXb_3H2jD7nX1r9u"
      )
      .then(
        () => {
          setSending(false);
          setSent(true);
          formRef.current.reset();
          setTimeout(() => setSent(false), 4000); // hide after 4s
        },
        (err) => {
          console.error(err);
          setSending(false);
          setError(true);
          setTimeout(() => setError(false), 4000);
        }
      );
  };

   useEffect(() => {
    window.scrollTo(0, 0);   
  }, []);

  useEffect(() => {
    AOS.init({
      duration: 1000, // animation duration (ms)
      once: true,     // whether animation should happen only once
      offset: 100,    // offset (in px) from the original trigger point
    });
  }, []);

  // Scroll reveal
  useEffect(() => {
    const els = document.querySelectorAll("[data-reveal]");
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) e.target.classList.add("reveal-in");
        });
      },
      { threshold: 0.15 }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  // Close mobile menu on route click
  const closeDrawer = () => setMenuOpen(false);

  // Cloud ERP cards content (logos animate; “angular” cards with hover effects)
  const erpCards = [
    {
      title: "Financials",
      desc: "Real-time GL, AP/AR, cashflow and automated reconciliations.",
    },
    {
      title: "Inventory",
      desc: "Multi-warehouse visibility, demand planning, lot & serial tracking.",
    },
    {
      title: "CRM",
      desc: "Pipeline management, tasks, reminders and 360° customer view.",
    },
    {
      title: "HR & Payroll",
      desc: "Onboarding, attendance, payroll runs and compliance in one place.",
    },
    {
      title: "Manufacturing",
      desc: "BOM, routing, MRP and shop-floor signals integrated to MES.",
    },
    {
      title: "Analytics",
      desc: "Dashboards, KPIs and alerts to drive faster decisions.",
    },
  ];

  return (
    <div className="larch-page">
     <Header />
      {/* Hero */}
      <section id="home" className="hero">
        <Swiper
          modules={[EffectCreative, Autoplay, Pagination, Navigation]}
          className="hero-slider"
          effect="cube"
cubeEffect={{
  shadow: false,
  slideShadows: false,
  shadowOffset: 20,
  shadowScale: 0.94,
}}
          loop
          grabCursor
          speed={900}
          autoplay={{ delay: 4500, disableOnInteraction: false }}
          pagination={{ clickable: true }}
          navigation
          creativeEffect={{
            prev: {
              shadow: true,
              translate: ["-120%", 0, -500],
              rotate: [0, 180, 0], // flip backward
              scale: 0.85,         // slight zoom-out on outgoing slide
            },
            next: {
              shadow: true,
              translate: ["120%", 0, -500],
              rotate: [0, -180, 0], // flip forward
              scale: 1.15,          // slight zoom-in on incoming slide
            },
          }}
        >
          <SwiperSlide>
            <div
              className="hero-slide"
              style={{
      backgroundImage: `url(${lerp})`,
    }}
  >
              <div className="hero-overlay" />
              <div className="hero-content">
                <h1>Production! Digitization! Maintenance!</h1>
                <h4>
                  Get your ERP with effective Maintenance, production order and workforce
                  management tool...
                </h4>
              </div>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div
              className="hero-slide"
              style={{
      backgroundImage: `url(${plan})`,
    }}
            >
              <div className="hero-overlay" />
              <div className="hero-content">
                <h1>Planning! Controlling! Intelligence!</h1>
                <h4>
                  Have you tracked your operator availability and machine status before
                  planning?
                </h4>
              </div>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div
              className="hero-slide"
               style={{
      backgroundImage: `url(${Equip})`,
    }}
            >
              <div className="hero-overlay" />
              <div className="hero-content">
                <h1>Equipment! Efficiency! Effectiveness!</h1>
                <h4>
                  Validate Machine, Manpower and Overall Equipment Efficiency (OEE) the
                  right way.
                </h4>
              </div>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div
              className="hero-slide"
              style={{
      backgroundImage: `url(${barcode})`,
    }}
            >
              <div className="hero-overlay" />
              <div className="hero-content">
                <h1>Smart Shopfloor! Avail Performance! Unlock Benefits!</h1>
                <h4>Realtime barcode inventory movement keeps your floor calm and in control.</h4>
              </div>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div
              className="hero-slide"
              style={{
      backgroundImage: `url(${collab})`,
    }}
            >
              <div className="hero-overlay" />
              <div className="hero-content">
                <h1>A Single Effective Collaborative Platform</h1>
                <h4>Operate efficiently with LarchERP—remove bottlenecks and grow.</h4>
              </div>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div
              className="hero-slide"
               style={{
      backgroundImage: `url(${ai})`,
    }}
            >
              <div className="hero-overlay" />
              <div className="hero-content">
                <h1>A Step Ahead to Industry 4.0...</h1>
                <h4>Drive the next level of standards with innovation and automation.</h4>
              </div>
            </div>
          </SwiperSlide>
        </Swiper>
      </section>
      {/* Hero Slider here */}

      {/* <div className="scrolling-text">
        <p>Welcome to Larch Technologies – Delivering Innovation with Excellence 🚀</p>
      </div> */}

      {/* About (image left -> text right) */}
<section id="aboutus" className="about-with-bg">
  <div className="about-bg" />  {/* background image + overlay */}

  <div className="about-pro">
    <div className="about-wrap container grid">
      {/* LEFT SIDE */}
      <div className="about-left">
        <h2 className="about-title" data-aos="fade-up">
          About Us
        </h2>

        <p className="about-tagline" data-aos="fade-up" data-aos-delay="120">
          We <span className="rotator">
            <span>innovate</span>
            <span>engineer</span>
            <span>deliver</span>
          </span> scalable &amp; impactful solutions.
        </p>

        <div className="about-points" data-aos="fade-up" data-aos-delay="240">
          <div className="point">
            <i className="fas fa-lightbulb" />
            <span>Product thinking &amp; rapid prototyping</span>
          </div>
          <div className="point">
            <i className="fas fa-users-cog" />
            <span>Cross-functional team: ERP, MES, IIoT</span>
          </div>
          <div className="point">
            <i className="fas fa-rocket" />
            <span>Quality, cost &amp; speed focused delivery</span>
          </div>
        </div>

        <div className="about-cta" data-aos="zoom-in" data-aos-delay="360">
           <a
    href="#contact"
    className="btn btn--primary big"
    onClick={(e) => {
      e.preventDefault(); // prevent instant jump
      const target = document.querySelector("#contact");
      if (target) {
        target.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }}
  >
    Let’s talk
  </a>
        </div>
      </div>

      {/* RIGHT SIDE */}
      <div className="about-right" data-aos="fade-left" data-aos-delay="200">
        <p>
          We at <strong>Larch Technologies</strong> Company offer cost-effective,
          customized, high-quality Enterprise Resource Planning (ERP) application
          development solutions for small and medium businesses. We provide strategic
          design services that enable our clients to increase sales, build brand
          awareness, and strengthen customer reliability.
        </p>
        <p>
          To best understand your business, we follow an incremental process of intake,
          research, innovation, and validation.
        </p>
        <p>
          We are proud to have the services of a large number of experienced
          development and management professionals working across process management
          solutions. If you are looking for a strong business process development team
          to build a dynamic Enterprise Application with diverse functions, we have
          the right experts for you.
        </p>
      </div>
    </div>
  </div>
</section>



      {/* MES (image left -> text right) */}
  {/* MES (video background + text overlay) */}

<section id="mes-system" className="mes-section relative w-full py-32">
  {/* Background Video */}
  <video autoPlay loop muted playsInline className="mes-bg-video ">
    <source src={mes} type="video/mp4" />
    Your browser does not support the video tag.
  </video>

  {/* Overlay Content */}
  <div className="container relative z-10 text-white flex flex-col items-center" data-aos="fade-left">
    
    {/* Heading & Intro */}
    <div className="text-center mb-12 max-w-3xl">
      <h1 className="mes-heading font-bold mb-4">
        MES ( Manufacturing Execution System )
      </h1>
      <p className="mb-2">Save money on the shop-floor using LarchMES system software.</p>
      <p className="mb-2">Enable accurate, real-time visibility to produce your final product.</p>
      <p className="mb-6">Track Part No, Machine, Lot No, Date/Time...</p>

      {/* Original Explore More button */}
      <Link to="/LarchMes" className="btn">
  Explore More <i className="fas fa-external-link-alt" />
</Link>
    </div>
<br></br>
<br></br>
    {/* Cards Section */}
<div className="cards-wrapper grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8 mt-12 w-full max-w-6xl">
  {[
    { title: "Injection Moulding MES", icon: <FaIndustry className="w-12 h-12 text-blue-600" />, link: "/injection-mould"  },
    { title: "Wiring Harness MES", icon: <FaPlug className="w-12 h-12 text-blue-600" />, link: "/Wirringharness" },
    { title: "Cable Assembly MES", icon: <FaNetworkWired className="w-12 h-12 text-blue-600" />, link: "/CableAssembly" },
    { title: "PCB Manufacturing MES", icon: <FaMicrochip className="w-12 h-12 text-blue-600" />, link: "/PCBManufucture" },
  ].map((card, idx) => (
    <a
      key={idx}
      href={card.link}
      // target="_blank"
      rel="noreferrer"
      className="mes-card group"
    >
      <div className="icon-wrapper mb-4 flex justify-center">{card.icon}</div>
      <h3 className="text-xl font-semibold text-center mb-2 group-hover:text-blue-600 transition">
        {card.title}
      </h3>
      <span className="explore-text flex items-center justify-center gap-1">
        Explore <span className="transition group-hover:translate-x-1">→</span>
      </span>
    </a>
  ))}
</div>

  </div>
</section>



{/* Cloud ERP Section */}
<section id="cloud-erp" className="about-with-bg">
  <div className="about-bg" style={{ backgroundImage: `url(${cloud})` }} />

  <div className="cloud-erp-container">
    <h2 className="section-title text-center" data-aos="fade-up">
      Cloud ERP
    </h2>
    <p
      className="section-subtitle text-center"
      data-aos="fade-up"
      data-aos-delay="120"
    >
      Modular, scalable and secure—pick the capabilities you need, and add more as you grow.
    </p>

    <div className="cloud-erp-grid" data-aos="fade-up" data-aos-delay="240">
      {[
        {
          icon: <FaChartBar className="icon" />,
          title: "Enterprise Applications",
          link: "/LarchErp",
        },
        {
          icon: <FaBoxes className="icon" />,
          title: "Industrial IoT",
          link: "/IOT",
        },
        {
          icon: <FaUsers className="icon" />,
          title: "AI/ML",
          link: "/AI_ML",
        },
        {
          icon: <FaMoneyBillWave className="icon" />,
          title: "Big Data Analytics",
          link: "/BigDataAnalytics",
        },
        {
          icon: <FaTruck className="icon" />,
          title: "Cloud Services",
          link: "/cloud-services",
        },
        {
          icon: <FaUserShield className="icon" />,
          title: "Digital Services",
          link: "/digital-services",
        },
      ].map((card, index) => (
        <div
          key={index}
          className="erp-card"
          data-aos="fade-up"
          data-aos-delay={index * 100}
        >
          <div className="icon-wrapper">{card.icon}</div>
          <h3>{card.title}</h3>
          <a href={card.link} className="explore-link">
            Explore →
          </a>
        </div>
      ))}
    </div>
  </div>
</section>





      {/* About Video Section */}
      {/* <section className="relative w-[20px] h-[200px] md:h-[350px] lg:h-[400px] mt-12">
      
        <video
          src={MyVideo}
          autoPlay
          loop
          muted
          className="absolute top-0 left-0 w-full h-full object-cover filter blur-sm brightness-50"
        />

       
      </section> */}



      {/* Traceability (kept as-is with default reveal) */}
      <section id="manufacturing-traceability" className="split split--alt container" data-reveal>
       <div className="split-img">
    <img src={trace} alt="Manufacturing Traceability" />
  </div>
        <div className="split-text">
          <h2>Manufacturing Traceability</h2>
          <p className="lead">Complete end-to-end track &amp; trace from GRN to dispatch.</p>
          <p className="lead">Stay competitive with full material and process genealogy.</p>
          <p>
            Know which supplier’s raw material went into each finished good; who received,
            produced and inspected, including lot/serial tracking at every step.
          </p>
          <a className="btn" href="path/to/your-document.pdf" target="_blank" rel="noreferrer">
            Explore More <i className="fas fa-external-link-alt" />
          </a>
        </div>
      </section>

      {/* Contact */}
      <section id="contact" className="contact" data-reveal>
        <div className="container">
          <div className="contact-header">
            <h2 className="accent">Get In Touch</h2>
            <p>We’d love to hear from you. Let’s connect today.</p>
          </div>

          <div className="contact-grid">
            <div className="card">
              <h3 className="accent center">Contact Information</h3>

              <div className="info">
                <span>📍</span>
                <p>
                  <strong>Regd. Office:</strong><br />
                  S1, 2nd Floor, Plot No.16, Bharani Nagar,<br />
                  Kattupakkam, Chennai - 600 056,<br />
                  Tamilnadu, India.
                </p>
              </div>

              <div className="info">
                <span>📍</span>
                <p>
                  <strong>Development Office:</strong><br />
                  No. 24, 1st Floor, Old Agraharam Street,<br />
                  Chinna Chokkikuklam, Madurai - 625 002,<br />
                  Tamilnadu, India.
                </p>
              </div>

              <div className="info">
                <span>📧</span>
                <p>
                  <strong>Email:</strong> <a href="mailto:sales@larch.in">Sales@larch.in</a>
                </p>
              </div>

              <div className="info">
                <span>📞</span>
                <p><strong>Phone:</strong> +91 9884164415</p>
              </div>

              <div className="info">
                <span>📞</span>
                <p><strong>Phone:</strong> +91 7010448048,+91 8300930356</p>
                

              </div>

              <p className="center dim">
                <strong>We’re here to help!</strong><br />
                Feel free to call or email us for any inquiries.
              </p>
            </div>

            <div className="card">
              <h3 className="accent">Send Us a Message</h3>
            {/* Success & Error Messages */}
            {sent && <p className="success-msg">✅ Message sent successfully!</p>}
            {error && <p className="error-msg">❌ Failed to send message. Please try again later.</p>}

            <form ref={formRef} onSubmit={sendEmail}>
              <input type="text" name="name" placeholder="Your Name" required />
              <input type="email" name="email" placeholder="Your Email" required />
              <input type="text" name="designation" placeholder="Your Designation" required />
              <input type="tel" name="contact" placeholder="Contact No" required />
              <input type="text" name="subject" placeholder="Subject" required />
              <textarea name="message" placeholder="Your Message" required />

              <button type="submit" className="btn btn--fill" disabled={sending}>
                {sending ? (
                   <span className="sending-text">
                  <span className="loader"></span> Sending...
                  </span>
                ) : (
                  "Send Message"
                )}
              </button>
            </form>

            </div>
          </div>
        </div>
      </section>

     <Footer />
      <ERPChatbot />

    </div>
  );
};

export default Homepage;
